export const LOCALSTORAGE_DATABASE_STATUS = 'routable:localstorage:status';
export const LOCALSTORAGE_RECORD_UPDATE = 'routable:localstorage:update';
export const LOCALSTORAGE_RECORD_UPDATE_MULTIPLE = 'routable:localstorage:update:multiple';
export const LOCALSTORAGE_RECORD_DELETE = 'routable:localstorage:delete';
export const LOCALSTORAGE_RECORD_DELETE_MULTIPLE = 'routable:localstorage:delete:multiple';
export const LOCALSTORAGE_RECORD_CLEARED = 'routable:localstorage:cleared';
